export default {
    // récuperer toutes les entites dans la base de données 
    // get_all_plafonds(serverParams){
    //     return axios.post('/operations/plafond', {
    //         headers: {
    //             Authorization: "Bearer " + token
    //         }
    //     }) 
    // },
    get_delais(){
        return axios.get('/operations/retrait/delais', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_plafonds() {
        return axios.get('/parametrages/plafond', {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    },
    get_all_authentites(serverParams){
        return axios.get('/authentite?page=' + serverParams.page, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_typesentite(){
        return axios.get('/typesentite', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les entites dans la base de données 
    put_plafonds(id_plafond,plafond){
        return axios.put('/parametrages/plafond/'+id_plafond, plafond, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_plafonds_autorisation(num_transation){
        return axios.post('/operations/autoriser/retrait', num_transation, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    put_delais(id_delais,delais){
        return axios.put('/operations/retrait/delais/' + id_delais, delais, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_entites(id,entite){
        
        return axios.put('/entites/'+id,entite, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_entites(id){
        return axios.get('/entites/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_entites(id){
        return axios.delete('/entites/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}